export const CHECKBOX = 'Checkbox';
export const RADIO = 'Radio';
export const TEXTBOX = 'Textbox';
export const TEXTAREA = 'Textarea';
export const DROPDOWN = 'Dropdown';
export const LOOKUP = 'Searchable Dropdown';
export const READONLY = 'Readonly';
export const MULTISELECT = 'Multi-Select Dropdown';
export const DATEPICKER = 'Datepicker';